import { Component } from '@angular/core';
import { MonitorComponent } from '../../monitor.component';
import { MonitorEndpointsService } from '../../../common';
import { tokenIntvertColorFlashAnimation } from '../../../common/common.animation';

@Component({
  selector: 'app-monitor-horz',
  templateUrl: './monitor-horz.component.html',
  styleUrls: ['./monitor-horz.component.scss'],
  providers: [MonitorEndpointsService],
  animations: [tokenIntvertColorFlashAnimation()],
})
export class MonitorHorzComponent extends MonitorComponent {}
